import UI from 'constants/ui';
import styled from 'styled-components';

export const PageWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin: 12.5rem 0;
`;

export const PageIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const PageTitle = styled.h1`
  margin: 1rem 0 0.5rem 0;
  color: white;
  font-weight: 700;
  font-size: ${UI.text.h2};
  line-height: 130%;
`;

export const SubTitle = styled.p`
  color: white;
  font-weight: 400;
  font-size: ${UI.text.lg};
`;

export const BackToHomeBtn = styled.div`
  margin-top: 2.5rem;
`;
